/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { ASSIGN_APP_LOCATION, ACTIVE_BUTTON_INDEX } from './types';

export const initialState = {
  value: null,
  index: 0
};

export const appLocationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ASSIGN_APP_LOCATION:
      return {
        ...state,
        value: action.location
      };
    case ACTIVE_BUTTON_INDEX:
      return {
        ...state,
        index: action.index
      };
    default:
      return state;
  }
};
